import React, { useState, useEffect } from "react";
import { Row, ToastContainer, Col } from "react-bootstrap";
import Toast from "react-bootstrap/Toast";
import ReactDOM from "react-dom";
import * as commondaData from "../../Common";

const MessagePopup = ({ board_data, setShow, show }) => {
  return (
    <Row>
      <Col>
        {board_data.board && (
          <ToastContainer
            position={`${board_data.position || "top_end"}`}
            className="p-3"
          >
            <Toast
              className="d-inline-block m-1"
              bg={board_data.bg || "primary"}
              onClose={() => setShow(!show)}
              show={show}
              delay={3000}
              autohide
            >
              <Toast.Header>
                <strong className="me-auto">
                  {commondaData.firstUpper(board_data.title)}
                </strong>{" "}
              </Toast.Header>
              <Toast.Body className="Dark text-white">
                {commondaData.firstUpper(board_data.message)}
              </Toast.Body>
            </Toast>
          </ToastContainer>
        )}
      </Col>
    </Row>
  );
};

const Message = (props) => {
  const board_data = props.board;
  const [show, setShow] = useState(false);

  useEffect(() => {
    setShow(board_data.board);
  }, [board_data]);

  return ReactDOM.createPortal(
    <MessagePopup board_data={props.board} setShow={setShow} show={show} />,
    document.getElementById("message")
  );
};

export default Message;
